import { ApiResourceMethod } from '@/api/api-requests-factory';
import { BaseResponse } from '@/api/api-requests-factory/models/response.model';
import { TransactionOperatingSystemListItem } from '@/models/dictionary/transaction-operating-system-list.model';

export default class GetTransactionOperationSystemListRequest
  extends ApiResourceMethod<TransactionOperatingSystemListItem[]> {
  public perform(wlSlug: string): Promise<TransactionOperatingSystemListItem[]> {
    return this.performer.requestWithMapper(
      {
        url: `${wlSlug}/dictionary/bpTransactionOs`,
      },
      (payload: BaseResponse<TransactionOperatingSystemListItem[]>) => {
        return payload.data;
      },
    );
  }
}
